// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoader_container__CkTpf","loader":"PageLoader_loader__CLvTG"};